import React from 'react';

interface Props {
	text: string;
}

const EscapeWithLines: React.FC<Props> = ({ text }) => {
	const handleQuotes = (text: string) => {
		// @ts-ignore
		return text.replaceAll('&quot;', '"');
	};

	return (
		<>
			{text.split('\n').map((item, idx) => {
				return (
					<span key={idx}>
						{handleQuotes(item)}
						<br />
					</span>
				);
			})}
		</>
	);
};

export default EscapeWithLines;
